import React from 'react';
import Workflow from '../../components/Workflow';

function WorkflowsPage() {
  return (
    <div className="p-6">
      <h1 class="text-2xl font-semibold text-gray-800 dark:text-gray-100 mb-6">Workflows</h1>
      <div className="bg-white rounded-lg shadow-lg p-4">
        
        <h2 className="text-xl font-semibold mb-4 text-[#6C63FF]">Rate Booking Automation</h2>
        <Workflow />
      </div>
    </div>
  );
}

export default WorkflowsPage; 